import { useState, useCallback, useRef } from 'react';
// import { Student, AddStudent } from '../types/batch.types';
import { Student, AddStudent } from '../types/batch.types'
import { ApiService } from '../../api/api-service';
import { showNotification } from '@mantine/notifications';

export const useStudentManagement = () => {
  const [loading, setLoading] = useState(false);
  const [studentsDropdown, setStudentsDropdown] = useState<{ label: string; value: string; name: string }[]>([]);
  const studentsRef = useRef<Student[]>([]);

  const fetchStudents = useCallback(async () => {
    try {
      setLoading(true);
      const response = await ApiService.getInstance().get("/students/all-students");
      studentsRef.current = response.data;

      const formattedStudents = response.data.map(({ email, name }: Student) => ({
        label: email,
        value: email,
        name: name,
      }));
      setStudentsDropdown(formattedStudents);
    } catch (error) {
      console.error("Error fetching students:", error);
      showNotification({
        title: "Error",
        message: "Failed to fetch students",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const createStudent = useCallback(async (studentData: AddStudent) => {
    try {
      setLoading(true);
      const response = await ApiService.getInstance().post("/students", studentData);

      studentsRef.current.push({
        ...studentData,
        currency: "",
        paymentStatus: "",
        comment: "",
        studentClasses: ""
      });

      const newStudentOption = {
        label: studentData.email,
        value: studentData.email,
        name: studentData.name,
      };

      setStudentsDropdown((prev) => [...prev, newStudentOption]);

      showNotification({
        title: "Success",
        message: `Student ${studentData.name} added successfully`,
        color: "green",
      });
      return true;
    } catch (error) {
      console.error("Error creating student:", error);
      showNotification({
        title: "Error",
        message: "Failed to create student",
        color: "red",
      });
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchNextStudentId = useCallback(async () => {
    try {
      const response = await ApiService.getInstance().get("/students/latest-id");
      console.log(response);

      const latestStudentId = response.data.latestStudentId || "0";
      return (parseInt(latestStudentId, 10) + 1).toString();
    } catch (error) {
      console.error("Error fetching next student ID:", error);
      return "0";
    }
  }, []);

  const validateStudentEmail = useCallback((email: string) => {
    const normalizedEmail = email.trim().toLowerCase();
    return !studentsRef.current.some(
      (s: Student) => (s.email?.trim().toLowerCase() ?? "") === normalizedEmail
    );
  }, []);

  return {
    loading,
    setLoading,
    studentsDropdown,
    setStudentsDropdown,
    studentsRef,
    fetchStudents,
    createStudent,
    fetchNextStudentId,
    validateStudentEmail,
  };
}; 